export default __webpack_public_path__ + "static/graphic-experiments-320-91e4ccda2a09054d01530cda9c53be2d.svg";